<template>
  <main>
    <component :is="mode" :user="user" @switch-mode="mode = $event"></component>
  </main>
</template>

<script>
  import EnrollmentOversight from './enrollment-oversight/EnrollmentOversight.vue';
  import MyStudySites from './MyStudySites.vue';

  export default {
    name: 'Studies',
    components: { MyStudySites, EnrollmentOversight },
    props: {
      user: Object,
    },
    data() {
      return {
        mode: 'my-study-sites',
      };
    },
    created() {
      let hasOversight = this.user.permissions.some(p => p.name === 'access enrollment oversight');
      if (hasOversight) {
        this.mode = 'enrollment-oversight';
      }
    },
  };
</script>
